var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElement3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3323 7.0966V3.31382C18.3323 2.13899 17.799 1.66406 16.4742 1.66406H13.1081C11.7833 1.66406 11.25 2.13899 11.25 3.31382V7.08827C11.25 8.27143 11.7833 8.73803 13.1081 8.73803H16.4742C17.799 8.74636 18.3323 8.27143 18.3323 7.0966Z",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3323 16.4742V13.1081C18.3323 11.7833 17.799 11.25 16.4742 11.25H13.1081C11.7833 11.25 11.25 11.7833 11.25 13.1081V16.4742C11.25 17.799 11.7833 18.3323 13.1081 18.3323H16.4742C17.799 18.3323 18.3323 17.799 18.3323 16.4742Z",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75027 7.0966V3.31382C8.75027 2.13899 8.21701 1.66406 6.8922 1.66406H3.52603C2.20122 1.66406 1.66797 2.13899 1.66797 3.31382V7.08827C1.66797 8.27143 2.20122 8.73803 3.52603 8.73803H6.8922C8.21701 8.74636 8.75027 8.27143 8.75027 7.0966Z",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75027 16.4742V13.1081C8.75027 11.7833 8.21701 11.25 6.8922 11.25H3.52603C2.20122 11.25 1.66797 11.7833 1.66797 13.1081V16.4742C1.66797 17.799 2.20122 18.3323 3.52603 18.3323H6.8922C8.21701 18.3323 8.75027 17.799 8.75027 16.4742Z",
    stroke: "#292D32",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement3);
export default __webpack_public_path__ + "static/media/element-3.4f8214da05823348f7b56bfea5dcea38.svg";
export { ForwardRef as ReactComponent };